import FeatureName from '@constants/featureName';
import { useFeatureFlagContext } from '@contexts/FeatureFlagContext';

/**
 * Custom hook for reactive feature flag usage
 * This hook automatically re-renders components when the feature flag changes
 *
 * @param featureName - The feature flag to watch
 * @returns Current state of the feature flag
 */
export function useFeatureFlag(featureName: FeatureName): boolean {
  const context = useFeatureFlagContext();

  // Directly return the current value from context
  // The context provider handles triggering re-renders when values change
  return context.isFeatureOn(featureName);
}

export default useFeatureFlag;
